import { useTheme } from '../contexts/ThemeContext';
import { useFont } from '../contexts/FontContext';
import BackButton from '../components/BackButton';
import { useEffect } from 'react';

export default function TermsOfService() {
  const { theme } = useTheme();
  const { font } = useFont();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pricingTable = [
    {
      name: 'Abonnement Timide',
      content: 'Accès aux cours',
      duration: '30 j. / 365 j.',
      visio: '—',
      qcm: '10 QCM/jour',
      price: '15 €/mois ou 165 €/an'
    },
    {
      name: 'Abonnement Motivé',
      content: 'Cours',
      duration: '30 j. / 365 j.',
      visio: '—',
      qcm: 'Illimités',
      price: '22 €/mois ou 240 €/an'
    },
    {
      name: 'Abonnement Déterminé (mensuel)',
      content: 'Cours + visios groupe illimitées (≥ 1/mois)',
      duration: '30 j.',
      visio: 'Groupe illimitées',
      qcm: 'Illimités',
      price: '35 €/mois'
    },
    {
      name: 'Abonnement Déterminé (annuel)',
      content: 'Cours + visios groupe illimitées (≥ 1/mois) + 2 visios individuelles',
      duration: '365 j.',
      visio: 'Groupe illimitées + 2 individuelles',
      qcm: 'Illimités',
      price: '450 €/an'
    },
    {
      name: 'Visio groupe "One‑shot"',
      content: 'Session thématique 1 h',
      duration: 'À la date choisie',
      visio: '1 groupe',
      qcm: '—',
      price: '25 €'
    },
    {
      name: 'Visio individuelle "One‑shot"',
      content: 'Session personnalisée 1 h',
      duration: 'À la date choisie',
      visio: '1 individuelle',
      qcm: '—',
      price: '50 €'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: font.family }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <BackButton />
        </div>

        <div className="bg-white rounded-xl shadow-sm p-8">
          <h1 className={`text-3xl font-bold text-${theme.text} mb-8`}>
            Conditions Générales de Vente
          </h1>

          <div className="prose max-w-none">
            <p className="text-sm text-gray-500 mb-4">Version 1.0 – 20 avril 2025</p>
            <p className="text-gray-600 mb-8">
              Site : loustaletformation.fr<br />
              Éditeur : Loustalet formation – Statut entreprise EURL L'oustalet, Conseils et Formations SIRET 893 608 976 00013
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Objet</h2>
            <p className="text-gray-600 mb-4">
              Les présentes CGV régissent la vente de formations et de services d'accompagnement en ligne proposés sur le Site loustaletformation.fr.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Offres et tarifs</h2>
            <div className="overflow-x-auto">
              <table className="w-full mb-4">
                <thead>
                  <tr className="border-b">
                    <th className="py-2 px-4 text-left">Formule</th>
                    <th className="py-2 px-4 text-left">Contenu</th>
                    <th className="py-2 px-4 text-left">Durée d'accès</th>
                    <th className="py-2 px-4 text-left">Visios incluses</th>
                    <th className="py-2 px-4 text-left">QCM</th>
                    <th className="py-2 px-4 text-left">Prix TTC*</th>
                  </tr>
                </thead>
                <tbody>
                  {pricingTable.map((plan, index) => (
                    <tr key={index} className="border-b">
                      <td className="py-2 px-4">{plan.name}</td>
                      <td className="py-2 px-4">{plan.content}</td>
                      <td className="py-2 px-4">{plan.duration}</td>
                      <td className="py-2 px-4">{plan.visio}</td>
                      <td className="py-2 px-4">{plan.qcm}</td>
                      <td className="py-2 px-4">{plan.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-sm text-gray-500 mb-8">*TVA non applicable, art. 293 B CGI.</p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Processus de commande</h2>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Choix de la formule</li>
              <li>Création/connexion compte Client</li>
              <li>Acceptation des CGV et, le cas échéant, renonciation au droit de rétractation</li>
              <li>Paiement sécurisé via Stripe Checkout</li>
              <li>E‑mail de confirmation (valant contrat)</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Paiement</h2>
            <p className="text-gray-600 mb-4">
              Les paiements (one‑shot et récurrents) sont traités par Stripe Payments Europe. Les données bancaires ne transitent jamais par le Site. Sont acceptés : CB Visa, MasterCard, American Express, Apple Pay, etc.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Abonnements : reconduction & résiliation</h2>
            <p className="text-gray-600 mb-4">
              Reconduction tacite : à chaque échéance, pour la même durée.<br /><br />
              Notification L215‑1 : un e‑mail rappelle au Client son droit de non‑reconduction entre 3 mois et 1 mois avant l'échéance.<br /><br />
              Résiliation : possible à tout moment depuis l'espace Client ou par e‑mail ; effet à la période suivante, sans remboursement prorata.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Droit de rétractation</h2>
            <p className="text-gray-600 mb-4">
              Consommateur : 14 jours (art. L221‑18 C. conso). Accès immédiat aux contenus = renonciation expresse avant paiement.<br /><br />
              Professionnel (formation pro) : 10 jours (Code du travail).
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Absence de droit de rétractation pour les "one‑shot" exécutées dans le délai</h2>
            <p className="text-gray-600 mb-4">
              Conformément à l'art. L221‑28‑13°, le droit de rétractation ne s'applique pas aux prestations pleinement exécutées avant la fin du délai de 14 jours lorsque l'exécution a commencé avec l'accord du consommateur.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Propriété intellectuelle</h2>
            <p className="text-gray-600 mb-4">
              Tous les contenus (textes, vidéos, QCM, marque « L'oustalet formation ») sont protégés par le Code de la propriété intellectuelle. Toute reproduction sans autorisation est interdite.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. Responsabilité, force majeure, données personnelles</h2>
            <h3 className="text-lg font-medium mt-6 mb-3">9.1 Responsabilité de Loustalet formation</h3>
            <p className="text-gray-600 mb-4">Loustalet formation s'engage à fournir les services de formation en ligne avec toute la diligence raisonnablement attendue d'un professionnel. Toutefois :</p>
            <p className="text-gray-600 mb-4">L'accès au Site peut être momentanément suspendu pour maintenance, mises à jour ou défaillance des réseaux sans engager la responsabilité de Loustalet formation.</p>
            <p className="text-gray-600 mb-4">Loustalet formation ne saurait être tenue pour responsable d'un retard ou défaut d'exécution imputable :</p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>au Client (matériel ou connexion internet inadaptés, informations inexactes) ;</li>
              <li>à un tiers (hébergeur, opérateur télécom, prestataire de paiement, etc.).</li>
            </ul>
            <p className="text-gray-600 mb-4">En aucun cas Loustalet formation ne pourra être tenue responsable des dommages indirects (perte de chiffre d'affaires, de données, préjudice commercial…) ni d'un montant supérieur au prix effectivement payé par le Client pour la prestation litigieuse.</p>

            <h3 className="text-lg font-medium mt-6 mb-3">9.2 Force majeure</h3>
            <p className="text-gray-600 mb-4">Les obligations des Parties seront suspendues en cas de survenance d'un événement de force majeure tel que défini par l'article 1218 du Code civil et la jurisprudence : catastrophe naturelle, incendie, panne électrique majeure, guerre, actes terroristes, pandémie, décisions gouvernementales, grève des réseaux de télécommunication, etc.</p>
            <p className="text-gray-600 mb-4">La Partie empêchée notifiera l'autre Partie dans les plus brefs délais. Si l'empêchement excède 30 jours consécutifs, chacune pourra résilier le contrat par lettre recommandée sans indemnité.</p>

            <h3 className="text-lg font-medium mt-6 mb-3">9.3 Données personnelles</h3>
            <div className="overflow-x-auto">
              <table className="w-full mb-4">
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">Responsable de traitement</td>
                    <td className="py-2 px-4">Loustalet formation, adresse : 45 rue haute saint paterne, 36100 ISSOUDUN,
                      e‑mail : <a href="mailto:loustaletformation@gmail.com"
                                  className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a></td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">Données collectées</td>
                    <td className="py-2 px-4">Nom, prénom, adresse e‑mail, données de facturation ; résultats aux QCM ; logs de connexion ; aucune donnée sensible. Les données bancaires sont traitées exclusivement par Stripe.</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">Finalités & bases légales</td>
                    <td className="py-2 px-4">
                      • Gestion des Commandes et accès aux Formations : exécution du contrat (art. 6‑1‑b RGPD).<br />
                      • Facturation : obligation légale (art. L123‑22 C. com.).<br />
                      • Mesure d'audience Google Analytics 4 : consentement (art. 6‑1‑a RGPD).
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">Durées de conservation</td>
                    <td className="py-2 px-4">
                      • Données clients : durée de la relation + 3 ans pour la prospection (recommandation CNIL).<br />
                      • Factures : 10 ans (art. L123‑22 C. com.).<br />
                      • Logs techniques : 12 mois.
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">Destinataires</td>
                    <td className="py-2 px-4">Éditeur, sous‑traitants techniques (Heroku, Stripe, Google Workspace/Forms).</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">Transferts hors UE</td>
                    <td className="py-2 px-4">Stripe et Google sont situés aux USA ; transferts encadrés par le Data Privacy Framework ou clauses contractuelles types.</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">Droits des personnes</td>
                    <td className="py-2 px-4">Accès, rectification, effacement, limitation, opposition, portabilité ; exercice par e‑mail à [À compléter] ou courrier à l'adresse ci‑dessus. Réclamation possible auprès de la CNIL.</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-medium">DPO</td>
                    <td className="py-2 px-4">Aucun DPO désigné (struct. &lt; 250 employés, traitements non sensibles).</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-gray-600 mb-4">L'utilisation du Site emporte acceptation de la Politique de confidentialité détaillée (consultable via le lien en pied de page) et du bandeau cookies permettant d'exprimer son consentement à l'Analytics.</p>

            <h2 className="text-xl font-semibold mt-8 mb-4">10. Médiation</h2>
            <p className="text-gray-600 mb-4">
              Médiateur de la consommation : La Société Médiation Professionnelle, <a
                href="https://www.mediateur-consommation-smp.fr" target="_blank" rel="noopener noreferrer"
                className="text-rose-500 hover:text-rose-600">www.mediateur-consommation-smp.fr</a> Alteritae 5 rue
              Salvaing 12000 Rodez.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">11. Droit applicable & juridiction</h2>
            <p className="text-gray-600 mb-4">
              Contrat régi par le droit français ; tribunaux compétents du siège de Loustalet formation.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">12. Archivage</h2>
            <p className="text-gray-600 mb-4">
              Les contrats et factures sont archivés 10 ans : demande par e‑mail à <a href="mailto:loustaletformation@gmail.com" className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}